<template>
  <div class="aiCompany CompanyHome">
    <Header></Header>
    <div class="CompanyHomeBg">
      <img alt="" src="@a/aicompany/images/bg1.jpg" />
    </div>
    <div class="CompanyHome_content">
      <loginWindow style="z-index: 999999" v-if="showLogin" @close="showLogin=false"></loginWindow>
      <div class="CompanyHome_content_title">
        <div class="content_title_dd">AI公司名称一键生成</div>
        <div class="content_title_dt">几秒内即可创建多个公司名称，并对接工商数据支持名称查重</div>
      </div>
      <div class="CompanyHome_content_form">
        <div class="content_form_left">

          <!-- 城市选择 -->
          <div class="form_left_list city">
            <div class="left_list_title">
              <img alt="" src="@a/aicompany/images/bn20.png" />
              <div class="list_title_right">
                <el-cascader
                  placeholder="请选择城市"
                  size="large"
                  :options="options"
                  v-model="selectedCity"
                  @change="handleChange"
                  filterable
                  :show-all-levels="false"
                  >
                </el-cascader>
              </div>
            </div>
          </div>

          <div class="form_left_icon"></div>

          <!-- 行业选择 -->
          <div class="form_left_list industry">
            <div class="left_list_title">
              <img alt="" src="@a/aicompany/images/bn21.png" />
              <div class="list_title_right">
                <el-input
                  v-model="selectedIndustry"
                  placeholder="请选择/输入行业"
                  @focus="onInputFocus"
                  @blur="onInputBlur"
                ></el-input>
                <i class="el-input__icon el-icon-arrow-down"></i>
              </div>
            </div>
            <div class="left_list_down" v-if="showIndustryDropdown">
              <div class="list_down_bottom scroll">
                <!-- 遍历 categories 渲染分类和内容 -->
                <div
                  class="down_bottom_list"
                  v-for="(category, index) in categories"
                  :key="index"
                >
                  <div class="bottom_list_left">{{ category.name }}</div>
                  <div class="bottom_list_right">
                    <div
                      class="list_right_li"
                      :class="{ active: activeItem === item }"
                      v-for="(item, subIndex) in category.items"
                      :key="subIndex"
                      @click="selectCategory(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form_left_icon"></div>
        </div>
        <div class="content_form_right">
          <input
              type="text"
              placeholder="例:一家专注于半导体研发生产的科技公司"
              v-model="description"
          />
          <div class="form_right_btn" @click="goToCompanyGenerate">一键生成</div>
        </div>
      </div>

      <!-- 分类渲染 -->
      <div class="CompanyHome_content_tag">
        <div class="content_tag_title">不知道如何上手？试试快速生成吧。</div>
        <div class="content_tag_txt hover">
          <div
              class="tag_txt_list"
              v-for="(category, index) in companyCategories"
              :key="category.id"
              @click="selectCompanyCategory(index)"
              :class="{ active: index === selectedCategoryIndex }"
          >
            {{ category.name_cn }}
          </div>
        </div>
      </div>

      <!-- 详情渲染 -->
      <div class="CompanyHome_content_tag2 hover">
        <div
            class="content_tag2_list"
            v-for="detail in companyCategories[selectedCategoryIndex]?.detail"
            :key="detail.id"
            @click="selectDetail(detail.describe)"
        >
          <div class="tag2_list_title">{{ detail.title }}</div>
          <div class="tag2_list_txt">{{ detail.describe }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Header from '@c/aiCompanyheader/aiCompanyheader'
import { pcTextArr } from 'element-china-area-data'
import loginWindow from "@c/common/loginWindow/loginWindow";


export default {
  name: 'CompanyHome',
  data() {
    return {
      showLogin: false,
      // 城市选择数据
      options: this.customizeCityData(pcTextArr),
      selectedOptions: [],
      selectedCity: [],
      selectedIndustry: "",

      // 行业选择数据
      showIndustryDropdown: false,
      input: '',
      activeItem: null, // 当前选中的类目
      // 所有分类和内容数组
      categories: [
        {
          name: "常用类",
          items: [
            "网络科技",
            "电子商务",
            "投资",
            "咨询",
            "广告",
            "零售",
            "制造",
            "餐饮",
            "文化",
          ],
        },
        {
          name: "科技类",
          items: [
            "网络科技",
            "电子科技",
            "化工科技",
            "环保科技",
            "能源科技",
            "新能源科技",
            "环境科技",
            "教育科技",
            "生物科技",
            "智能科技",
            "金融科技",
            "信息科技",
            "软件",
            "游戏",
          ],
        },
        {
          name: "金融类",
          items: [
            "投资",
            "融资",
            "保险",
            "货币金融",
            "资本市场服务",
          ],
        },
        {
          name: "商贸类",
          items: [
            "医疗器械",
            "机械设备",
            "游乐设备",
            "电子电器",
            "电子产品",
            "电子商务",
            "运输设备",
            "建材",
            "商贸",
            "贸易",
            "工贸",
            "国际贸易",
            "零售",
            "销售",
          ],
        },
        {
          name: "服务类",
          items: [
            "食品",
            "餐饮",
            "租赁",
            "住宿",
            "物流",
            "房地产",
            "人力资源",
            "建筑装潢",
            "美容美发",
            "翻译",
            "礼仪服务",
            "劳动派遣",
            "物业管理",
            "商务服务",
            "房屋经纪",
            "专利代理",
            "人才发展",
            "广告",
            "设计",
            "平面设计",
            "广告设计",
            "形象设计",
            "市场营销",
            "修理服务",
          ],
        },
        {
          name: "咨询类",
          items: [
            "财务咨询",
            "商务咨询",
            "科技咨询",
            "技术咨询",
            "税务咨询",
            "工程咨询",
            "会计咨询",
            "投资咨询",
            "投资咨询",
            "产业咨询",
            "健康咨询",
            "医疗咨询",
            "建筑咨询",
            "企业管理咨询",
          ],
        },
        {
          name: "产品类",
          items: [
            "服饰",
            "袜业",
            "箱包",
            "家具",
            "木业",
            "礼品",
            "工艺品",
            "化妆品",
            "汽配",
            "汽车用品",
            "电子产品",
            "电子电器",
          ],
        },
        {
          name: "管理类",
          items: [
            "商务管理",
            "置业管理",
            "建设管理",
            "企业管理",
            "投资管理",
            "财务管理",
            "品牌管理",
            "风险管理",
            "认证管理",
            "环境管理",
            "医院管理",
            "社会管理",
            "公共管理",
          ],
        },
        {
          name: "教育类",
          items: [
            "教育",
            "文化教育",
            "艺术教育",
          ],
        },
        {
          name: "文娱类",
          items: [
            "娱乐",
            "文化",
            "体育",
            "电影电视",
            "新闻",
          ],
        },
        {
          name: "信息类",
          items: [
            "信息网络",
            "数码信息",
            "信息发展",
            "劳动信息网络",
            "通信信息",
            "信息装备",
            "航旅信息",
            "交通信息",
          ],
        },
        {
          name: "工程类",
          items: [
            "建筑工程",
            "建筑安装工程",
            "建筑装饰工程",
            "设备安装",
            "机电工程",
            "市政工程",
            "电气设备",
            "工程设备",
            "机械设备",
            "运输设备",
          ],
        },
        {
          name: "跨五大行业实业类",
          items: [
            "实业",
            "企业发展",
            "实业发展",
            "经济发展",
          ],
        },
        {
          name: "其他产业类",
          items: [
            "农业",
            "渔业",
            "畜牧业",
            "林业",
            "采矿业",
            "制造业",
            "供应业",
          ],
        },
      ],

      // 描述输入数据
      description: "",
      companyCategories: [], // 分类数据
      selectedCategoryIndex: 0, // 当前选中分类索引

    };
  },
  created() {
    this.loadFromLocalStorage();
    // 请求接口获取数据
    this.fetchCategories();
    // 请求接口获取地址
    this.getCityData();

    console.log('是否登录',this.$store.getters.isLogin);
    if (this.$store.getters.isLogin) {
    }else{
      //未登录需要会员强制登录
      this.showLogin=true;
    }

  },
  mounted() {
    
  },
  components: {
    loginWindow,
    Header
  },
  computed: {
   
  },
  methods: {
    customizeCityData(data) {
      // 需要特殊处理的直辖市和新增城市
      const targetCities = ['北京市', '天津市', '重庆市', '上海市'];

      // 正则表达式移除后缀，包括“省”“市”“自治区”“自治州”“特别行政区”等及族名
      const suffixes = /(省|市|自治区|特别行政区|自治州|彝族|壮族|回族|维吾尔|藏族|傣族景颇族|傈僳族|白族|纳傣族|苗族|古族)$/;

      // 新增城市
      const additionalCities = [
        { label: '台湾', children: [{ label: '台湾', value: '台湾' }] },
        { label: '香港', children: [{ label: '香港', value: '香港' }] },
        { label: '澳门', children: [{ label: '澳门', value: '澳门' }] }
      ];

      // 合并现有数据和新增城市
      return data.concat(additionalCities).map(region => {
        if (targetCities.includes(region.label)) {
          // 对特定城市进行独立处理
          return {
            label: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
            value: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
            children: [{ 
              label: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
              value: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, '').toLowerCase() 
            }]
          };
        }

        // 对其他区域保持不变，同时去掉“自治州”后缀
        return {
        ...region,
          label: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
          value: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
          children: region.children
          ? region.children.map(child => ({
              ...child,
              label: child.label.replace('自治区', '').replace('自治州', '').replace(suffixes, '') 
            }))
          : []
        };
      });
    },


    // 切换行业下拉菜单
    // 输入框聚焦时显示下拉菜单
    onInputFocus() {
      this.showIndustryDropdown = true;
    },
    // 输入框失焦时隐藏下拉菜单
    onInputBlur() {
      setTimeout(() => {
        this.showIndustryDropdown = false;
      }, 200);
    },
    // 选中类目时处理逻辑
    selectCategory(item) {
      this.activeItem = item; // 设置当前激活的类目
      this.selectedIndustry = item; // 将选中的值赋值给输入框
    },
    handleChange (value) {
      console.log(value)
    },

    async goToCompanyGenerate() {
      try {
        // 保存数据到 localStorage（可选，如果需要在本地存储中保留这些数据）
        this.saveToLocalStorage();

        // 准备发送的数据
        const dataToSend = {
          selectedCity: this.selectedCity || "",  // 默认空字符串
          selectedIndustry: this.selectedIndustry || "",
          description: this.description || ""  // 加载描述
        };

        // 使用 axios 发送 POST 请求，将数据传给后端接口
        const response = await this.axios.post('api/CompanyName/createCompanyName', dataToSend);

        // 判断接口响应
        if (response && response.code === 1) {
          console.log('接口响应：', response);
          //把后端返回的unique_id存起来
          localStorage.setItem('unique_id', response.result.unique_id);
          // 跳转到目标页面
          this.$router.push('/aicompany/companyGenerate/companyGenerate');
        } else {
          console.error("接口返回错误:", response);
          alert(response.msg || '接口返回错误')
        }
      } catch (error) {
        console.error('请求失败：', error);
        alert('请求失败：' + error.message);
        // 可添加错误处理逻辑，如弹出提示等
      }
    },

    // 保存所有数据到 localStorage
    saveToLocalStorage() {
      const data = {
        selectedCity: this.selectedCity,
        selectedIndustry: this.selectedIndustry,
        description: this.description, // 添加描述
      };
      localStorage.setItem('CompanyHomeData', JSON.stringify(data));
    },

    // 加载数据从 localStorage
    loadFromLocalStorage() {
      const data = JSON.parse(localStorage.getItem('CompanyHomeData'));
      if (data) {
        this.selectedCity = data.selectedCity || "";
        this.selectedIndustry = data.selectedIndustry || "";
        this.description = data.description || ""; // 加载描述
      }
    },

    async fetchCategories() {
      try {
        const data = await this.axios.get('api/CompanyName/getCompanyCategory');
        if (data.code === 1) {
          this.companyCategories = data.result;
        } else {
          console.error("接口返回错误:", data.msg);
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },

    selectCompanyCategory(index) {
      this.selectedCategoryIndex = index; // 更新选中的分类索引
      this.selectedIndustry = this.companyCategories[index].name_cn; // 更新选中的行业名称
    },

    selectDetail(describe) {
      this.description = describe; // 更新选中的描述
    },

    //请求接口获取地址
    getCityData() {

      //如果this.selectedCity不为空，说明已经请求过数据，不再重复请求
      if (this.selectedCity.length > 0) {
        return;
      }

      this.axios.get('api/CompanyName/getRegion').then(res => {
        if (res.code === 1) {
          this.selectedCity = res.result;
        }
      });

    },

  },
}


</script>

<style>

@import "CompanyHome.css";
.tag_txt_list {
  cursor: pointer;
  padding: 10px;
  margin: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: inline-block;
}

.tag_txt_list.active {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.content_tag2_list {
  margin-bottom: 10px;
}
</style>




